export default "/images/ditforsikringshus.png?5aef93745ff514ba2ff8e6aa9d74dbc8";